import { useStoreHasLogisticChannel } from '../../hooks';

export const LogisticPermissionControl = ({
  children,
  storeId,
  fallbackNode,
  loadingNode,
}: {
  storeId?: string | null;
  fallbackNode?: React.ReactNode;
  loadingNode?: React.ReactNode;
  children?: React.ReactNode;
}) => {
  const permissions = useStoreHasLogisticChannel({
    storeId: storeId || null,
  });

  if (permissions.loading) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{loadingNode}</>;
  }

  if (permissions.hasLogisticsChannel) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{fallbackNode}</>;
};
